import { RefObject, useEffect } from 'react';

const MARGIN_GAP = 10;
const HEADER_HEIGHT = 60;

function useCustomHeaderOnScroll(
  parentRef: RefObject<any> | null,
  customHeaderRef: RefObject<any> | null,
  headerRef?: RefObject<any> | null,
) {
  useEffect(() => {
    let scrollTop: number;
    const header = headerRef?.current;
    const parent = parentRef?.current || window;

    const handleScroll = () => {
      if (!parentRef) {
        scrollTop = parent.scrollY;
      } else {
        scrollTop = parent.scrollTop;
      }

      if (customHeaderRef?.current && scrollTop > (HEADER_HEIGHT - MARGIN_GAP)) {
        customHeaderRef.current.style.display = 'flex';
      }

      if (customHeaderRef?.current && scrollTop <= (HEADER_HEIGHT - MARGIN_GAP)) {
        customHeaderRef.current.style.display = 'none';
      }

      if (!header) return;

      if (scrollTop > 1) {
        if (!header.classList.contains('on-scroll')) {
          header.classList.add('on-scroll');
        }
      } else {
        header.classList.remove('on-scroll');
      }
    };

    parent?.addEventListener('scroll', handleScroll);

    return () => parent?.removeEventListener('scroll', handleScroll);
  }, [parentRef, customHeaderRef, headerRef]);
}

export default useCustomHeaderOnScroll;
